import { z } from 'zod';
export const AuditLogEntrySchema = z.object({
    id: z.string().uuid(),
    itemId: z.string().uuid(),
    userId: z.string().uuid().nullable(),
    action: z.string(),
    fieldSlug: z.string().nullable().optional(),
    fieldName: z.string().nullable().optional(),
    oldValue: z.unknown().nullable(),
    newValue: z.unknown().nullable(),
    details: z.record(z.unknown()),
    author: z
        .object({
        id: z.string().uuid(),
        login: z.string(),
        displayName: z.string(),
    })
        .nullable(),
    createdAt: z.string(),
});
export const AuditLogResponseSchema = z.object({
    entries: z.array(AuditLogEntrySchema),
    /**
     * Резолв GUID-ов в человекочитаемые подписи: для reference-полей —
     * значение display-колонки справочника; для cross_link — title записи.
     * Используется фронтом, чтобы в истории показывать «Иванов С. Г.»
     * вместо `c1f3...`.
     */
    resolvedRefs: z.record(z.string()).optional(),
});
